export default __webpack_public_path__ + "bml-characteristic2.3aa3bd9.png";